// extracted by mini-css-extract-plugin
module.exports = {"answer":"Questions_answer__2U_4w","header":"Questions_header__6j3-G","wrapper":"Questions_wrapper__1y0YA","form":"Questions_form__XG9ll"};